
export class Popover {
    constructor(){
        this.element 
    }
    add(options){
        if(options.element){
            this.element = options.element
            new bootstrap.Popover(this.element, options)
        }
    }
}